import type { StickerRewardScreenModel } from './StickerRewardScreenModelScreen';

export class StickerRewardScreenController {
  constructor(private readonly model: StickerRewardScreenModel) {}

  handleClaim = () => {
    this.model.onClaim?.();
  };
}
